import { SITE_COLORS, SITE_TEXT_PRESETS } from './theme';
export const getStyle = style => {
  var _style$styleParams, _style$styleParams2, _style$styleParams3, _style$styleParams4;
  return {
    ...style,
    styleParams: {
      colors: (style == null || (_style$styleParams = style.styleParams) == null ? void 0 : _style$styleParams.colors) ?? {},
      booleans: (style == null || (_style$styleParams2 = style.styleParams) == null ? void 0 : _style$styleParams2.booleans) ?? {},
      numbers: (style == null || (_style$styleParams3 = style.styleParams) == null ? void 0 : _style$styleParams3.numbers) ?? {},
      fonts: (style == null || (_style$styleParams4 = style.styleParams) == null ? void 0 : _style$styleParams4.fonts) ?? {},
      googleFontsCssUrl: ''
    },
    siteColors: SITE_COLORS,
    siteTextPresets: SITE_TEXT_PRESETS
  };
};
//# sourceMappingURL=get-style.js.map